import { Loading, useTranslate } from 'react-admin';
import React from 'react';
import { useGetMambuLedgerConfiguration, useGetMambuLedgerStatus } from '~/hooks/ledgers';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import { l } from '~/resources/ledgers/mambu/components/ConfigurationForm';
import { time } from '~/utils';
import Table from '@material-ui/core/Table';
import cx from 'classnames';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '../../../../components/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

const StatusTab = () => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const { isLoading: isLoadingStatus, data: statusData } = useGetMambuLedgerStatus();
  const {
    isLoading: isLoadingConfiguration,
    data: configurationData,
  } = useGetMambuLedgerConfiguration();

  const classes = useStyles();

  const tasks = [
    'externalAccountLinkRegistration' as const,
    'accountMirroring' as const,
    'externalProfileLinkSync' as const,
    'transactionTransferMirroring' as const,
  ];

  if (isLoadingStatus) {
    return <Loading />;
  }

  return (
    <Grid container justify='space-between'>
      <Grid item xs={12} className={classes.headerSection}>
        <Table className={cx(classes.table, { [classes.autoWidth]: true })}>
          <TableHead>
            <TableRow>
              <TableCell>{t('task')}</TableCell>
              <TableCell>{t('status')}</TableCell>
              <TableCell>{t('lastErrorTimestamp')}</TableCell>
              <TableCell>{t('lastErrorMessage')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tasks.map((task) => {
              const isEnabled = !!configurationData?.[task]?.enabled;
              const hasError = !!statusData?.[task]?.lastErrorTimestamp;
              const lastErrorTimestamp = statusData?.[task]?.lastErrorTimestamp
                ? time(statusData?.[task]?.lastErrorTimestamp).format('LLL')
                : undefined;
              const lastErrorMessage = statusData?.[task]?.lastErrorMessage;

              return (
                <TableRow key={task}>
                  <TableCell>{t(task)}</TableCell>
                  <TableCell>
                    {isLoadingConfiguration ? null : !isEnabled ? (
                      <RemoveCircleIcon className={cx(classes.icon, classes.disabled)} />
                    ) : !hasError ? (
                      <CheckCircleIcon className={cx(classes.icon, classes.success)} />
                    ) : (
                      <CancelIcon className={cx(classes.icon, classes.error)} />
                    )}
                  </TableCell>
                  <TableCell>{lastErrorTimestamp}</TableCell>
                  <TableCell>{lastErrorMessage}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  headerSection: {
    '& .sectionActions': {
      opacity: 0.5,
      transition: `opacity ${theme.transitions.easing.easeIn}`,
      transitionDuration: `${theme.transitions.duration.shortest}ms`,
    },
    '&:hover': {
      '& .sectionActions': {
        opacity: 1,
      },
    },
  },
  icon: {
    fontSize: '25px',
  },
  success: {
    color: theme.palette.success.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  disabled: {
    color: theme.palette.grey.A200,
  },
  table: {
    width: '100%',
    '& > tbody': {
      '& > tr': {
        '& > td:first-child': {
          width: '20%',
        },
        '& > td:nth-child(2)': {
          width: '15%',
        },
        '& > td:nth-child(3)': {
          width: '15%',
        },
        '& > td:nth-child(4)': {
          width: '50%',
        },
      },
    },
  },
  autoWidth: {},
}));

export default StatusTab;
